import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useCallback } from 'react';
// @ts-expect-error module not typed
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickedMoveToInboxCommentInput } from '../../usage-tracking/utils/threadInteraction';
import { jsx as _jsx } from "react/jsx-runtime";
const MoveToInboxAddComment = ({
  comment,
  setComment
}) => {
  const handleCommentOnChange = useCallback(evt => setComment(evt.target.value), [setComment]);
  const handleCommentInputOnClick = useCallback(() => {
    trackEvent(getClickedMoveToInboxCommentInput());
  }, []);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.moveToInboxPrompt.commentInputTitle"
    }),
    marginBlock: "400",
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "move-to-inbox-comment-input",
      value: comment,
      onChange: handleCommentOnChange,
      onClick: handleCommentInputOnClick
    })
  });
};
MoveToInboxAddComment.displayName = 'MoveToInboxAddComment';
export default MoveToInboxAddComment;